export const formatPhoneNumber = (phoneNumberString: string | undefined, includeCountryCode: boolean = false) => {
  if (!phoneNumberString) {
    return null;
  }
  const cleaned = ('' + phoneNumberString).replace(/\D/g, '');
  const normalized = cleaned.length === 11 && cleaned.startsWith('1')
    ? cleaned.slice(1)
    : cleaned;
  const match = normalized.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return includeCountryCode
      ? '+1 (' + match[1] + ') ' + match[2] + '-' + match[3]
      : '(' + match[1] + ') ' + match[2] + '-' + match[3];
  }
  return null;
};
